const mainSearchForm = {
  flights: "Skrydžiai", // translated 
  tours: "Ekskursijos", // translated 
  hotel: "Viešbutis", // translated 
  hotels: "Viešbučiai", // translated 
  services: "Paslaugos", // translated 
  search: "PAIEŠKA", // translated 
  destination: "Kelionės tikslas", // translated 
  includedServices: "Įtrauktos paslaugos", // translated 
  packageDuration: "Paketo trukmė", // translated 
  checkInOut: "Įsiregistravimas/išvykimas", // translated 
  guests: "Svečiai", // translated 
  adults: "Suaugusieji", // translated 
  children: "Vaikai", // translated 
  child: "Vaikas", // translated 
  age: "Amžius", // translated 
  yearsOld: "Metų", // translated 
  rooms: "Kambariai", // translated 
  close: "Uždaryti", // translated 
  searchType: "Paieškos tipas", // translated 
  accommodation: "Apgyvendinimas", // translated 
  transfers: "Pervedimai", // translated 
  toursExperiences: "Ekskursijos/Patyrimai", // translated 
  nights: "Naktys", // translated 
  days: "Dienos", // translated 
  packageType: "Paketo tipas", // translated 
  tourType: "Ekskursijos tipas", // translated 
  packages: "Paketai", // translated 
  cars: "Automobiliai", // translated 
  cruises: "Kruizai", // translated 
  infantsInSeat: "Kūdikiai sėdynėje", // translated 
  infantsOnLap: "Kūdikiai ant kelių", // translated 
  airport: "Oro uostas", // translated 
  passengers: "Keleiviai", // translated 
  departureReturn: "Išvykimo ir grįžimo datos", // translated 
  origin: "Kilmė", // translated 
  roundTrip: "Kelionė pirmyn ir atgal", // translated 
  isRoundTrip: "Yra Kelionė pirmyn ir atgal", // translated 
  dream_packages: "Svajonių paketai", // translated 
  partying: "Vakarėliai", // translated 
  thingsToDo: "Dalykai, kuriuos reikia padaryti", // translated 
};



export default mainSearchForm;
